import React from 'react';
import { Text, RadioButton } from '@moda/om';
import classNames from 'classnames';

import './CheckoutHeaderStep.scss';

interface Props {
  title: string;
  checked?: boolean;
}

export const CheckoutHeaderStep: React.FC<Props> = ({ title, checked }) => (
  <div
    className={classNames('CheckoutHeaderStep', {
      'CheckoutHeaderStep--checked': checked
    })}
  >
    <RadioButton checked={checked} readOnly aria-label={`${title} step`} />
    <Text className="CheckoutHeaderStep__title">{title}</Text>
  </div>
);
